import React from "react";
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Link } from '@mui/material';

import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const CartonCard = ({ item, sections, onEditClick, onDeleteClick }) => {
  const sectionName =
    sections?.find(
      (section) => section.ID_SECCION === item.seccion_id
    )?.NOMBRE_SECCION || "Sección no encontrada";

  return (
    <Grid item xs={6} sm={4} md={3} key={item.id}>
      <Item>
        <img
          src={item.url}
          alt={item.image}
          style={{ 
            width: '150px', 
            height: '140px', 
            objectFit: 'cover', 
            marginBottom: '8px' 
          }}
        />
        <Typography 
          variant="body2" 
          component="h2"
          sx={{
            maxHeight: '38px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            whiteSpace: 'normal',
            width: '100%',
            textAlign: 'center',
            marginBottom: '8px',
          }}
        >
          {item.autor}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'gray',
            marginBottom: '8px',
          }}
        >
          {sectionName}
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 'auto' }}>
          <Link 
            href={item.testigo.startsWith('http') ?
              item.testigo :
              `http://${item.testigo}`} target="_blank" rel="noopener noreferrer"
          >
            <IconButton>
              <LinkIcon />
            </IconButton>
          </Link>
          <IconButton aria-label="edit" onClick={() => onEditClick(item)}>
            <EditIcon />
          </IconButton>
          <IconButton aria-label="delete" onClick={() => onDeleteClick(item.id)}>
            <DeleteIcon />
          </IconButton>
        </div>
      </Item>
    </Grid>
  );
};
